export const GRID_VOLTAGE_LSP = "LSP";
export const GRID_VOLTAGE_HSP = "HSP";

export const GRID_VOLTAGE_OPTIONS = [
    { value: GRID_VOLTAGE_LSP, label: "Low voltage (LSP)" },
    { value: GRID_VOLTAGE_HSP, label: "High voltage (HSP)" },
];

export const GRID_VOLTAGE_SITE_OPTIONS = [
    { value: "", label: "Not set" },
    ...GRID_VOLTAGE_OPTIONS,
];

export function isValidGridVoltageLevel(value) {
    return value === GRID_VOLTAGE_LSP || value === GRID_VOLTAGE_HSP;
}

export const GRID_PEAK_POWER_HIGHEST_HOUR = "HighestHour";
export const GRID_PEAK_POWER_TOP3_AVERAGE = "Top3Average";

export const GRID_PEAK_POWER_OPTIONS = [
    { value: GRID_PEAK_POWER_HIGHEST_HOUR, label: "Highest hourly peak" },
    { value: GRID_PEAK_POWER_TOP3_AVERAGE, label: "Average of the three highest hourly peaks" },
];

export function getGridVoltageOptions(t) {
    return GRID_VOLTAGE_OPTIONS.map((option) => ({
        ...option,
        label: t(`grid.voltage.${option.value}`, { defaultValue: option.label }),
    }));
}

export function getGridVoltageSiteOptions(t) {
    return [
        { value: "", label: t("common.notSet") },
        ...getGridVoltageOptions(t),
    ];
}

export function getGridPeakPowerOptions(t) {
    return GRID_PEAK_POWER_OPTIONS.map((option) => ({
        ...option,
        label: t(`grid.peakPower.${option.value}`, { defaultValue: option.label }),
    }));
}

export function normalizePeakPowerMode(value) {
    return value === GRID_PEAK_POWER_TOP3_AVERAGE
        ? GRID_PEAK_POWER_TOP3_AVERAGE
        : GRID_PEAK_POWER_HIGHEST_HOUR;
}

// Tariffs are scoped by their GridArea (global or organization-owned).
